var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"loading-page"},[_c('div',{staticClass:"loading-content",attrs:{"role":"status","aria-live":"polite"}},[_c('img',{staticClass:"loading-heart",attrs:{"src":require("../images/ban6/love.png"),"alt":""}}),_c('p',{staticClass:"loading-text"},[_vm._v(" "+_vm._s(_vm.$t('pro2.loading'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }